export function setNotebookCollapse(state, payload) {
  return {
    ...state,
    drawerCollapsed: payload,
  };
}
